export const documentRoutes = {
  documentList: '/',
  updateDocument: '/update/:documentId',
  createDocument: '/new',
  createDocumentCopy: '/new/:documentId',
  handoverPackSectionList: '/handover-pack-sections',
  createHandoverPackSection: '/handover-pack-sections/new',
  updateHandoverPackSection: '/handover-pack-sections/update/:handoverPackSectionId',
};

export const documentsRoot = `/documents`;

export const handoverPackSectionsRoot = `${documentsRoot}/handover-pack-sections`;

export const getUpdateDocumentUrl = (documentId: number) => `${documentsRoot}/update/${documentId}`;

export const createDocumentUrl = `${documentsRoot}/new`;

export const getCopyDocumentUrl = (documentId: number) => `${documentsRoot}/new/${documentId}`;

export const createHandoverPackSectionUrl = `${handoverPackSectionsRoot}/new`;

export const getUpdateSectionUrl = (sectionId: number) => `${handoverPackSectionsRoot}/update/${sectionId}`;
